import type { SymbolDefinition } from "../types.ts";

export const switchSpst: SymbolDefinition = {
  id: "ep-switch-spst",
  familyKey: "switch",
  deviceKind: "switch",
  version: "0.1.0",
  label: { sv: "Strömbrytare", en: "Switch" },
  description: { sv: "Enpolig strömbrytare.", en: "Single-pole switch." },
  viewBox: "0 0 24 24",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <line x1="12" y1="2" x2="12" y2="8"/>
      <line x1="10" y1="8" x2="16" y2="16"/>
      <line x1="12" y1="16" x2="12" y2="22"/>
    </g>
  `,
  terminals: [
    { id: "in", kind: "phase", label: "L", position: "top", offset: 0.5 },
    { id: "out", kind: "phase", label: "T", position: "bottom", offset: 0.5 },
  ],
  designationPrefix: "S",
  searchKeywords: ["strömbrytare", "switch"],
};
